import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import Navbar from "../../../components/Navbar";
import { tokens, GET, PUT, getStorage, format_date, success_url, float, loading } from "../../../components/CustomComponent.js";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import THBText from "thai-baht-text";
import LOGO from "../../../assets/images/logo.png";
import Switch from "react-switch";

const size = {
  A4: { width: 1116, height: 1578, zoom: 0.7 }, A5: { width: 1116, height: 1578, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 1371, zoom: 0.385 }, "9 x 11 นิ้ว": { width: 1116, height: 1371, zoom: 0.7 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.7 },
};
const padding = {
  A4: { paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 }, A5: { paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 },
  "4.5 x 5.5 นิ้ว": { paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 }, "9 x 11 นิ้ว": { paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 },
  "9 x 5.5 นิ้ว": { paddingLeft: 24, paddingRight: 48, paddingTop: 32, paddingBottom: 32 },
};

export default class RecieptOther extends Component {
  state = {
    modal_text: false, text: "", type: "", document_data: null,
    setting: {
      size: "A4", paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16,
      header_1: { status: true, title: "-รูปภาพ" }, header_2: { status: true, title: "" }, header_3: { status: true, title: "" },
      header_4: { status: true, title: "-ใบเสร็จรับเงิน" }, header_5: { status: true, title: "-เลขที่" }, header_6: { status: true, title: "-วันที่" },
      header_7: { status: true, title: "-ได้รับเงินจาก" }, header_8: { status: true, title: "-ที่อยู่" }, header_9: { status: true, title: "-ชำระโดย" },
      header_10: { status: true, title: "-วันที่" }, th_1: { status: true, title: "-ลำดับ" }, th_2: { status: true, title: "-รายการ" },
      th_3: { status: true, title: "-รวมเป็นเงิน" }, tr_4: { status: true, title: "-รวมเป็นเงิน" }, tr_5: { status: true, title: "-ปรับปรุงยอดเงิน" },
      tr_6: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" }, footer_1: { status: true, title: "-จำนวนเงิน (ตัวอักษร)" },
      footer_2: { status: true, title: "" }, footer_3: { status: true, title: "-ลงชื่อ" }, footer_4: { status: true, title: "" }, footer_5: { status: true, title: "" },
    },
  };

  async componentDidMount() {
    loading(false); // ปิด Loading ทันทีที่เข้าหน้าแรก
    await this.Get();
  }

  Get = async () => {
    loading(true);
    let r = await GET(tokens, `v1/TH/document-manage/detail/custom-document/${getStorage("project_id")}`, null);
    if (r?.status) {
      this.setState({ document_data: r.data.data, setting: r.data.data.receipt_other || this.state.setting });
    }
    loading(false);
  };

  Update = async () => {
    loading(true);
    let r = await PUT(tokens, "v1/TH/document-manage/update/custom-document", { ...this.state.document_data, receipt_other: this.state.setting });
    if (r?.status) success_url("/receipt-other");
    loading(false);
  };

  UpdateStatus = (type) => this.setState(prev => ({ setting: { ...prev.setting, [type]: { ...prev.setting[type], status: !prev.setting[type].status } } }));

  // Helper Functions ช่วยย่อ UI
  dNone = (key) => this.state.setting[key]?.status ? "" : " d-none";
  countCol = (...keys) => keys.reduce((sum, k) => sum + (this.state.setting[k]?.status ? 1 : 0), 0);
  
  renderSwitch = (label, key, hasEdit = false) => (
    <div className="d-flex flex-wrap mb-1">
      <div className="wpx-120 d-flex">
        {label}
        {hasEdit && (
          <label className="wpx-20 hpx-20 bg-warning-light rounded-1 d-flex align-items-center justify-content-center icon text-warning pointer mx-1"
            onClick={() => this.setState({ modal_text: true, text: this.state.setting[key].title, type: key })}>{"\uf304"}</label>
        )}
      </div>
      <Switch height={20} width={40} checked={this.state.setting[key].status} onChange={() => this.UpdateStatus(key)} />
    </div>
  );

  renderPadInput = (label, key, plClass = "pr-1") => (
    <div className={`${plClass} w-100`}>
      <div className="pr-2 text-nowrap wpx-100">{label}</div>
      <input type="text" className="form-control" placeholder={label} value={this.state.setting[key]} onChange={(e) => float(e.target.value) && this.setState(s => ({ setting: { ...s.setting, [key]: e.target.value } }))} />
    </div>
  );

  render() {
    const s = this.state.setting;
    const showH1to6 = s.header_1.status || s.header_2.status || s.header_3.status || s.header_4.status || s.header_5.status || s.header_6.status;
    const showH7to10 = s.header_7.status || s.header_8.status || s.header_9.status || s.header_10.status;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="รายรับอื่นๆ" />
        <div className="body">
          <div className="p-3">
            <h4><b>รายรับอื่นๆ</b></h4>
            <div className="d-flex">
              <div style={{ width: 816.38 }}>
                <div className={`mx-auto bg-white ${s.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf"}`} style={{ ...size[s.size || "A4"], paddingLeft: Number(s.paddingLeft), paddingRight: Number(s.paddingRight), paddingTop: Number(s.paddingTop), paddingBottom: Number(s.paddingBottom) }}>
                  
                  <table className="table table-bordered mb-0 header">
                    <tbody>
                      <tr className={showH1to6 ? "" : "d-none"}>
                        <td rowSpan={2} className="border-bottom-0">
                          <div className="d-flex align-items-center">
                            <img src={getStorage("picture_paper") || LOGO} style={{ width: 92, height: 92, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain${this.dNone("header_1")}`} />
                            <div>
                              <h2 className={`fw-bold px-2 mb-0${this.dNone("header_2")}`}>{s.header_2.title}</h2>
                              <div className={`px-2${this.dNone("header_3")}`}>{s.header_3.title.split("\n").map((e, i) => (<div key={i}>{e}</div>))}</div>
                            </div>
                          </div>
                        </td>
                        <td className={`wpx-250 text-center border-bottom-0${this.dNone("header_4")}`}><h2 className="fw-bold mb-0">ใบเสร็จรับเงิน</h2></td>
                      </tr>
                      <tr className={showH1to6 ? "" : "d-none"}>
                        <td className="border-bottom-0 wpx-250">
                          <div className={this.dNone("header_5")}>เลขที่ : IW1000000001</div>
                          <div className={this.dNone("header_6")}>วันที่ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                        </td>
                      </tr>
                      <tr className={showH7to10 ? "" : "d-none"}>
                        <td className="border-bottom-0">
                          <div className={this.dNone("header_7")}>ได้รับเงินจาก : นายสมมติ นามสกุลสมมติ</div>
                          <div className={this.dNone("header_8")}>ที่อยู่ : 123/45 หมู่ 6 ต.หายยา อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50100</div>
                        </td>
                        <td className="border-bottom-0 wpx-250">
                          <div className={this.dNone("header_9")}>ชำระโดย : เงินสด</div>
                          <div className={this.dNone("header_10")}>วันที่ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="table table-bordered mb-0">
                    <tbody>
                      <tr>
                        <td className={`py-1 text-center wpx-50${this.dNone("th_1")}`}>ลำดับ</td>
                        <td className={`py-1 border-right-0 w-100${this.dNone("th_2")}`}>รายการ</td>
                        <td className={`py-1 border-left-0 wpx-130${this.dNone("th_2")}`} />
                        <td className={`py-1 text-center wpx-120${this.dNone("th_3")}`}>รวมเป็นเงิน</td>
                      </tr>
                      <tr>
                        <td className={`pt-1 text-center${this.dNone("th_1")}`}>1</td>
                        <td className={`pt-1 border-right-0${this.dNone("th_2")}`}>ค่าใช้จ่าย (จ่ายส่วนอื่นๆ)</td>
                        <td className={`border-left-0${this.dNone("th_2")}`} />
                        <td className={`text-right${this.dNone("th_3")}`}>0.00</td>
                      </tr>
                      <tr>
                        <td colSpan={this.countCol("th_1", "th_2")} rowSpan={3} className="border-0">
                          <div className="d-flex">
                            <div className="w-100">
                              <div className={`w-100 d-flex position-relative mt-3 text-nowrap${this.dNone("footer_1")}`}>
                                จำนวนเงิน (ตัวอักษร)
                                <div className="w-100 pl-1 position-relative">....................................................................................<span className="position-absolute" style={{ left: 6, bottom: 4 }}>{THBText(0)}</span></div>
                              </div>
                              <div className={this.dNone("footer_2")}>{s.footer_2.title.split("\n").map((e, i) => (<div key={i}>{e}</div>))}</div>
                            </div>
                            <div className="text-center">
                              <div className={`mt-5 text-nowrap${this.dNone("footer_3")}`}>ลงชื่อ...............................................ผู้รับเงิน</div>
                              <div className={this.dNone("footer_4")}>({s.footer_4.title})</div><div className={this.dNone("footer_5")}>{s.footer_5.title}</div>
                            </div>
                          </div>
                        </td>
                        <td className={`text-right pr-1 border-0${this.dNone("tr_4")}`}>รวมเป็นเงิน</td><td className={`text-right${this.dNone("tr_4")}`}>0.00</td>
                      </tr>
                      <tr className={this.dNone("tr_5")}><td className="text-right pr-1 border-0">ปรับปรุงยอดเงิน</td><td className="text-right">0.00</td></tr>
                      <tr className={this.dNone("tr_6")}><td className="text-right pr-1 border-0">รวมเป็นเงินทั้งสิ้น</td><td className="text-right">0.00</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* การตั้งค่า (ขวา) */}
              <div className="px-3 bg-white">
                <div className="px-4 pt-2">
                  <h5 className="fw-bold">ขนาดกระดาษ</h5>
                  <div className="d-flex align-items-center mb-2">
                    <div className="pr-2 text-nowrap wpx-100">ขนาดกระดาษ</div>
                    <select className="form-control" value={s.size} onChange={(e) => this.setState(prev => ({ setting: { ...prev.setting, size: e.target.value, ...padding[e.target.value] } }))}>
                      {Object.keys(size).map(sz => <option key={sz} value={sz}>{sz}</option>)}
                    </select>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <div className="pr-2 text-nowrap wpx-100">ระยะกระดาษ</div>
                    {this.renderPadInput("ด้านซ้าย", "paddingLeft")}
                    {this.renderPadInput("ด้านขวา", "paddingRight")}
                    {this.renderPadInput("ด้านบน", "paddingTop", "pl-1")}
                    {this.renderPadInput("ด้านล่าง", "paddingBottom", "pl-1")}
                  </div>
                </div>
                
                <div className="w-100 d-flex flex-wrap mb-auto">
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">หัวเอกสาร</h5>
                    {this.renderSwitch("โลโก้", "header_1")}
                    {this.renderSwitch("โครงการ", "header_2", true)}
                    {this.renderSwitch("ที่อยู่", "header_3", true)}
                    {this.renderSwitch("ใบเสร็จรับเงิน", "header_4")}
                    {this.renderSwitch("เลขที่", "header_5")}
                    {this.renderSwitch("วันที่", "header_6")}
                    {this.renderSwitch("ได้รับเงินจาก", "header_7")}
                    {this.renderSwitch("ที่อยู่", "header_8")}
                    {this.renderSwitch("ชำระโดย", "header_9")}
                    {this.renderSwitch("วันที่", "header_10")}
                  </div>
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">หัวตาราง</h5>
                    {this.renderSwitch("ลำดับ", "th_1")}
                    {this.renderSwitch("รายการ", "th_2")}
                    {this.renderSwitch("รวมเป็นเงิน", "th_3")}
                  </div>
                  <div className="py-3 px-4">
                    <h5 className="fw-bold">footer</h5>
                    {this.renderSwitch("รวมเป็นเงิน", "tr_4")}
                    {this.renderSwitch("ปรับปรุงยอดเงิน", "tr_5")}
                    {this.renderSwitch("รวมเป็นเงินทั้งสิ้น", "tr_6")}
                    {this.renderSwitch("จำนวนเงิน (ตัวอักษร)", "footer_1")}
                    {this.renderSwitch("หมายเหตุ", "footer_2", true)}
                    {this.renderSwitch("ลงชื่อ", "footer_3")}
                    {this.renderSwitch("ชื่อผู้รับเงิน", "footer_4", true)}
                    {this.renderSwitch("ตำแหน่งผู้รับเงิน", "footer_5", true)}
                  </div>
                </div>
                <div className="bg-white p-3"><button className="btn btn-primary w-100" onClick={this.Update}>บันทึก</button></div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={this.state.modal_text} onHide={() => this.setState({ modal_text: false })}>
          <Modal.Header><Modal.Title><b>แก้ไข</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-start mb-3">
              <label className="wpx-50">หัวข้อ :</label>
              <textarea className="form-control border-0 bg-contain validate" rows={5} placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ text: e.target.value })} value={this.state.text} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_text: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => {
                  let set = { ...this.state.setting };
                  set[this.state.type].title = this.state.text;
                  this.setState({ setting: set, modal_text: false });
                }}>บันทึก</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}